module.exports = __webpack_public_path__ + "img/session.ad86a285.png";